<template>
    <div class="bg-white mt-3 mx-2" @click="$emit('select')">
        <div class="inline-block w-full">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CardBase"
    }
</script>

<style scoped>

</style>